export function filterActiveShopLocalizations(localizations) {
  return localizations.filter((loc) => !loc.archived);
}

export function filterArchivedShopLocalizations(localizations) {
  return localizations.filter((loc) => !!loc.archived);
}
